import { css } from '@emotion/css';

import { IMAGE_OPTION_WIDTH } from '../../styles';

export const optionsListItemRootStyles = css`
  width: ${IMAGE_OPTION_WIDTH}rem;
`;

export const imageOverlayStyles = css`
  :hover {
    background: rgba(0, 0, 0, 0.44);
  }
`;
